import { useState } from 'preact/hooks';
import type { Stamp } from './types';

/**
 * One stamp, ported from Stamp.dc.html: the artwork when there is one, and
 * otherwise the procedural design for the stamp's series. If artwork fails to
 * load, the procedural design takes its place rather than a broken image.
 */
export function StampArt({ stamp: s }: { stamp: Stamp }) {
  const [broken, setBroken] = useState(false);
  const showImage = !!s.img && !broken;
  const series = s.mid ? 'mid' : s.half ? 'half' : s.eng ? 'eng' : s.series;

  return (
    <div class="stamp-wrap">
      <div class="stamp" role="img" aria-label={`${s.label}, ${s.denom}`}>
        {showImage ? (
          <img key={s.img} src={s.img} alt="" loading="lazy" onError={() => setBroken(true)} />
        ) : series === 'mid' ? (
          <div class="stamp-mid" style={{ background: s.color }}>
            <div class="stamp-mid-top">aéreo · {s.country}</div>
            <div class="stamp-mid-sun" />
            <div class="stamp-mid-hill" />
            <div class="stamp-mid-denom">{s.denom}</div>
          </div>
        ) : series === 'half' ? (
          <div class="stamp-half" style={{ backgroundColor: s.color }}>
            <div class="stamp-half-dots" style={{ backgroundImage: `radial-gradient(${s.color} 22%, transparent 23%)` }} />
            <div class="stamp-half-bar">
              <span>{s.label}</span>
              <b>{s.denom}</b>
            </div>
          </div>
        ) : (
          <div class="stamp-eng" style={{ color: s.color }}>
            <div class="stamp-eng-top">correo · {s.country}</div>
            <div class="stamp-eng-art" />
            <div class="stamp-eng-denom">
              <b>{s.denom}</b>
              <span class="stamp-eng-unit">CTVS</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
